import React from 'react';

import {Grid} from '@mui/material';
import {defineMessages, useIntl} from 'react-intl';

import {Head} from '@wheeebo/polaris-ui';

import AccountUpdateCard from '@components/pages/settings/AccountUpdateCard';
import AccountDeleteCard from '@components/pages/settings/AccountDeleteCard';

const msgs = defineMessages({
  headerTitle: {
    id: 'pages.member.SettingsPage.header.title',
    defaultMessage: 'Settings',
  },
});

function SettingsPage(): JSX.Element {
  const intl = useIntl();
  return (
    <Grid container spacing={1 / 2}>
      <Head title={intl.formatMessage(msgs.headerTitle)} />
      <Grid item xs={12} sm={4}>
        <AccountUpdateCard />
      </Grid>
      <Grid item xs={12} sm={4}>
        <AccountDeleteCard />
      </Grid>
    </Grid>
  );
}

export default React.memo(SettingsPage);
